import { Helmet } from "react-helmet-async";

interface OrganizationSchema {
  "@context": string;
  "@type": string;
  name: string;
  url: string;
  logo?: string;
  description?: string;
  contactPoint?: {
    "@type": string;
    telephone?: string;
    contactType: string;
    email?: string;
    availableLanguage: string;
  };
  address?: {
    "@type": string;
    addressCountry: string;
  };
}

interface WebSiteSchema {
  "@context": string;
  "@type": string;
  name: string;
  url: string;
  description?: string;
  potentialAction?: {
    "@type": string;
    target: string;
    "query-input": string;
  };
}

interface ServiceSchema {
  "@context": string;
  "@type": string;
  serviceType: string;
  provider: {
    "@type": string;
    name: string;
  };
  areaServed: string;
  description?: string;
}

interface BreadcrumbListSchema {
  "@context": string;
  "@type": string;
  itemListElement: Array<{
    "@type": string;
    position: number;
    name: string;
    item?: string;
  }>;
}

interface FAQPageSchema {
  "@context": string;
  "@type": string;
  mainEntity: Array<{
    "@type": string;
    name: string;
    acceptedAnswer: {
      "@type": string;
      text: string;
    };
  }>;
}

interface BlogPostingSchema {
  "@context": string;
  "@type": string;
  headline: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author: {
    "@type": string;
    name: string;
  };
  publisher: {
    "@type": string;
    name: string;
    logo: {
      "@type": string;
      url: string;
    };
  };
  mainEntityOfPage: {
    "@type": string;
    "@id": string;
  };
}

interface LocalBusinessSchema {
  "@context": string;
  "@type": string;
  name: string;
  image?: string;
  url?: string;
  address?: {
    "@type": string;
    addressLocality?: string;
    addressRegion?: string;
    addressCountry?: string;
  };
  areaServed?: {
    "@type": string;
    name: string;
  };
  priceRange?: string;
  description?: string;
}

type SchemaData = 
  | OrganizationSchema 
  | WebSiteSchema 
  | ServiceSchema 
  | BreadcrumbListSchema 
  | FAQPageSchema
  | BlogPostingSchema
  | LocalBusinessSchema
  | Record<string, any>;

interface StructuredDataProps {
  data: SchemaData | SchemaData[];
}

const StructuredData = ({ data }: StructuredDataProps) => {
  const schemas = Array.isArray(data) ? data : [data];

  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </Helmet>
  );
};

export default StructuredData;
